<div style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div style="margin-left:10px;margin-top:10px">
      <mat-form-field>
        <input matInput data-cy="driverDate" [matDatepicker]="date" [max]="maxDate" placeholder="Datum"
          formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Förare</mat-label>
        <mat-select data-cy="driverName" placeholder="Förare" formControlName="driver">
          <mat-option *ngIf="driverNames.length === 0" disabled>
            Inga rapporter för vald dag
          </mat-option>
          <mat-option *ngFor="let name of driverNames" [value]="name">
            {{name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button mat-flat-button data-cy="searchDriver " color="primary" type="submit"
        style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
    </div>
  </form>
</div>
<ngx-spinner #spinner [config]="spinnerConfig">
</ngx-spinner>
<div class="driver-reports">
  <ng-container *ngFor="let report of driverReports">
    <app-driver-report-details [driverReport]="report"></app-driver-report-details>
  </ng-container>
</div>
<div style="margin-top:10px">
  <button mat-flat-button data-cy="exportTotal" color="primary" (click)="exportSummary()" [disabled]="false"
    style="margin-left:10px;background:#7AB800">Exportera sammanställning</button>
</div>
